// Image configuration for Unicare Pharma website
// Using high-quality pharmaceutical and healthcare images from Unsplash

// Import local partner logos
import partner1 from '../assets/images/partner_1.jpeg';
import partner2 from '../assets/images/partner_2.jpeg';
import partner3 from '../assets/images/partner_3.jpeg';

export const images = {
  // Hero and About Images
  hero: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400&h=300&fit=crop&crop=center',
  about: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400&h=300&fit=crop&crop=center',
  contact: 'https://images.unsplash.com/photo-1524661135-423995f22d0b?w=400&h=250&fit=crop&crop=center',
  
  // Product Images
  products: {
    vitaminD3: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=400&h=300&fit=crop&crop=center',
    omega3: 'https://images.unsplash.com/photo-1559757175-0eb30cd8c063?w=400&h=300&fit=crop&crop=center',
    multivitamin: 'https://images.unsplash.com/photo-1471864190281-a93a3070b6de?w=400&h=300&fit=crop&crop=center',
    probiotics: 'https://images.unsplash.com/photo-1471864190281-a93a3070b6de?w=400&h=300&fit=crop&crop=center',
    antiAgingSerum: 'https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=400&h=300&fit=crop&crop=center',
    moisturizingCream: 'https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=400&h=300&fit=crop&crop=center',
    vitaminCCleanser: 'https://images.unsplash.com/photo-1596755389378-c31d21fd1273?w=400&h=300&fit=crop&crop=center',
    sunscreen: 'https://images.unsplash.com/photo-1556228720-195a672e8a03?w=400&h=300&fit=crop&crop=center'
  },
  
  // Partner/Company Logos (local images)
  partners: {
    partner1: partner1,
    partner2: partner2,
    partner3: partner3
  },
  
  // Alternative product images for variety
  alternatives: {
    supplements1: 'https://th.bing.com/th/id/OIP.weyN6-2yQUP7yvt2N4XYlQHaFt?w=217&h=180&c=7&r=0&o=7&pid=1.7&rm=3',
    supplements2: 'https://img.freepik.com/premium-photo/collection-cosmetic-skin-care-products_1167055-843.jpg',
    skincare1: 'https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?w=400&h=300&fit=crop&crop=center',
    skincare2: 'https://img.freepik.com/premium-photo/chic-pastel-cosmetics-packaging-skincare-fragrance-toiletries-serene-background_969707-2287.jpg',
    pharmacy1: 'https://img.freepik.com/premium-photo/3d-rendering-blank-product-background-cream-cosmetics-modern-red-podium-background_926199-1336464.jpg',
    pharmacy2: 'https://images.unsplash.com/photo-1583947215259-38e31be8751f?w=400&h=300&fit=crop&crop=center',
    medicine1: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400&h=300&fit=crop&crop=center',
    medicine2: 'https://images.unsplash.com/photo-1559757175-0eb30cd8c063?w=400&h=300&fit=crop&crop=center'
  }
};

export default images;